import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { createLink } from '@tanstack/react-router';

import { useGetUserInfoQuery } from '@/api/endpoints/users';

const LinkIconButton = createLink(IconButton);

const SidebarFooter = () => {
  const { data: user } = useGetUserInfoQuery(null);

  return (
    <Box alignItems='flex-end'>
      <Stack alignItems='center' gap={2}>
        <Divider sx={{ width: '100%' }} />

        <Stack
          direction='row'
          alignSelf='flex-start'
          pl={0.5}
          width='100%'
          justifyContent='space-between'
          overflow='hidden'
        >
          <Stack direction='row' alignItems='center' gap={1.5}>
            <Avatar alt='user'>
              {user?.email.at(0)?.toLocaleUpperCase() ?? 'U'}
            </Avatar>
            <Typography noWrap maxWidth={130}>
              {user?.email ?? 'User'}
            </Typography>
          </Stack>

          <Box alignSelf='flex-end'>
            <LinkIconButton to='/auth/logout' aria-label='Logout'>
              <LogoutOutlinedIcon />
            </LinkIconButton>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export default SidebarFooter;
